import {Component, ViewChild, Output, EventEmitter, ChangeDetectorRef, OnInit} from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { ModalConfig } from '../modal/modal-config';
import {BehaviorSubject} from "rxjs";
import {FileRecordObject} from "../records/file-record";
import {ValidationErrorsComponent} from "../data-table/validation-errors.component";
import {GuestValidationResult} from "./guest-validation-result";

@Component({
  selector: 'guest-file-validation-component',
  styleUrls: [ './guest-file-validation.component.css'],
  templateUrl: './guest-file-validation.component.html'
})

export class GuestFileValidationComponent implements OnInit {

  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;
  public showResults = new BehaviorSubject<boolean>(false);

  private modalTitle: string;
  private modalBody: string;
  private modalConfig: ModalConfig;

  @ViewChild(ValidationErrorsComponent)
  private modalValidationErrors: ValidationErrorsComponent;

  guestValidationResults: GuestValidationResult[] = [];
  headers = ['Filename', 'Validation Status', 'Sample Count', 'Message', 'View Errors']
  columnWidths = [23, 11, 11, 44, 13]

  public uploader: FileUploader = new FileUploader({
    url: '/upload/file/validate/guest',
    queueLimit: 1,
    autoUpload: true
  });

  @Output()
  uploaded: EventEmitter<string> = new EventEmitter();

  @ViewChild('guestError')
  private guestErrorModal: ModalComponent;

  getModalTitle() {
    return this.modalTitle;
  }

  getModalBody() {
    return this.modalBody;
  }

  getUploaderProgress() {
    if(this.uploader.progress === null) {
      return 0;
    } else if (isNaN(this.uploader.progress) ) {
      return 100;
    } else {
      return this.uploader.progress
    }
  }

  ngOnInit(): void {
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.uploader.onBeforeUploadItem = () => this.onBeforeUploadItem()
  }

  onChange(event: any): void {
  }

  onBeforeUploadItem(): void {
  }

  onSuccessItem(item: FileItem, response: any, status: number, headers: ParsedResponseHeaders): any {
    let data = JSON.parse(response);

    const newGuestValidationResult: GuestValidationResult = {
      filename: data['hmlid'],
      reportedStatus: data['status'],
      sampleCount: data['sampleCount'],
      validationMessage: data['message'],
      validationErrors: null
    }

    if (data['errors'] !== null && data['errors']['error'] !== null && data['errors']['error'].length > 0) {
      newGuestValidationResult.validationErrors = data['errors']['error'].map(key => {
        return {
          lineNumber: key['line'],
          sampleId: key['sampleId'],
          errorMessage: key['value']
        }
      });
    }

    this.guestValidationResults.unshift(newGuestValidationResult);
    this.uploader.clearQueue();
    this.clearFileUploadInputField();
  }

  onErrorItem(item: FileItem, response: any, status: number, headers: ParsedResponseHeaders): any {
    let data = JSON.parse(response);
    if (data['message'].indexOf('File uploaded is too large.') > 0) {
      this.modalConfig = {
        small: true,
        okBtnTitle: 'Continue',
        okBtnCssClass: 'btn btn-primary hml-button-validate-only',
        cancelBtnTitle: '',
        footerMessage: ''
      };
      this.modalTitle = `File Size Error`;
      this.modalBody = `File is too large to be submitted for validation.`
    }
    else if (data['message'].indexOf('Wrong file Type.') > 0) {
      this.modalConfig = {
        small: true,
        okBtnTitle: 'Continue',
        okBtnCssClass: 'btn btn-primary hml-button-validate-only',
        cancelBtnTitle: '',
        footerMessage: ''
      };
      this.modalTitle = `File Type Error`
      this.modalBody = `Invalid File Type submitted for validation. Valid file types are XML, HML and CSV.`;
    }
    else if (data['message'].indexOf('Invalid filename.') > 0) {
      this.modalConfig = {
        small: true,
        okBtnTitle: 'Continue',
        okBtnCssClass: 'btn btn-primary hml-button-validate-only',
        cancelBtnTitle: '',
        footerMessage: ''
      };
      this.modalTitle = `Invalid Filename Error`
      this.modalBody = `File submitted for validation has an invalid filename. Please fix the filename and retry.`;
    } else if (data['message'] === 'Unable to validate due to an internal error') {
      this.modalConfig = {
        small: true,
        okBtnTitle: 'Continue',
        okBtnCssClass: 'btn btn-primary hml-button-validate-only',
        cancelBtnTitle: '',
        footerMessage: ''
      };
      this.modalTitle = `Internal Error`
      this.modalBody = `An internal error has occurred during validation. Please make sure your file is complete and correctly formatted. Otherwise, please contact support.`;
    } else {
      this.modalConfig = {
        small: true,
        okBtnTitle: 'Continue',
        okBtnCssClass: 'btn btn-primary hml-button-validate-only',
        cancelBtnTitle: '',
        footerMessage: ''
      };
      this.modalTitle = `General Error`
      this.modalBody = `A server error occurred while validating your file. Please contact support.`;
    }

    this.guestErrorModal.open(this.modalConfig);
    this.uploader.clearQueue();
    this.clearFileUploadInputField();
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public modalContinueClick(e: any): void {

  }

  public clearFileUploadInputField(): void {
    (document.getElementById("files") as HTMLInputElement).value = '';
  }

  public showGuestValidationErrors(validationResult: GuestValidationResult): void {
    const validationErrors = validationResult.validationErrors;
    const filename = validationResult.filename;

    if (validationErrors && validationErrors.length > 0) {
      const guestValidationFileRecord: FileRecordObject = {
        currentEvent: "guest-validation",
        errors: validationErrors,
        eventDate: "n/a",
        fileLocation: "n/a",
        fileName: filename,
        fileSize: 0,
        fileType: "n/a",
        id: "n/a",
        sessionNumber: "n/a",
        status: "n/a",
        userName: "guest"
      }
      this.modalValidationErrors.open(guestValidationFileRecord)
    }
  }
}
